import { render, staticRenderFns } from "./DropdownModal.vue?vue&type=template&id=ff184d4a&scoped=true"
import script from "./DropdownModal.vue?vue&type=script&lang=js"
export * from "./DropdownModal.vue?vue&type=script&lang=js"
import style0 from "./DropdownModal.vue?vue&type=style&index=0&id=ff184d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff184d4a",
  null
  
)

export default component.exports